export default __webpack_public_path__ + "assets/411572ac29c9f35a4528066a45342815.svg";